import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Layouts from "../../layouts/layouts";
import CreatableSelect from "react-select/creatable";
export default function Create_assettype() {
  const title = "Add Asset Purchase";
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    assetname: "",
    cost: "",
    quantity: "",
    purchasedDate: "",
    purchasedFrom: "",
    company: "",
    description: "",
  });
  const [assetNames, setAssetNames] = useState([]);
  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  // ---------------------------------------------------
  // Validation
  // ---------------------------------------------------

  const validateForm = () => {
    const newErrors = {};

    if (!formData.assetname.trim()) {
      newErrors.assetname = "Asset name is required.";
    }

    if (formData.cost === "" || Number(formData.cost) <= 0) {
      newErrors.cost = "Valid cost is required.";
    }

    if (formData.quantity === "" || Number(formData.quantity) <= 0) {
      newErrors.quantity = "Valid quantity is required.";
    }

    if (!formData.purchasedDate) {
      newErrors.purchasedDate = "Purchased date is required.";
    }

    if (!formData.purchasedFrom.trim()) {
      newErrors.purchasedFrom = "Purchased from is required.";
    }

    if (!formData.company.trim()) {
      newErrors.company = "Company is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ---------------------------------------------------
  // Input Change
  // ---------------------------------------------------

  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchAssetNames = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/asset-types/names`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        console.log("Asset names response:", response.data);

        if (response.status === 200) {
          setAssetNames(response.data.assetNames || []);
        }
      } catch (error) {
        console.error(
          "Error fetching asset names:",
          error.response?.data || error,
        );
      }
    };

    fetchAssetNames();
  }, []);

  // ---------------------------------------------------
  // Submit
  // ---------------------------------------------------

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found");
      return;
    }

    const data = {
      assetname: formData.assetname.trim(),
      cost: Number(formData.cost),
      quantity: Number(formData.quantity),
      purchasedDate: formData.purchasedDate,
      purchasedFrom: formData.purchasedFrom.trim(),
      company: formData.company.trim(),
      description: formData.description.trim(),
    };

    console.log("Submitting AssetType:", data);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/asset-type/new`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/assettype");
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    }
  };

  return (
    <>
      <Layouts />

      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />

        <form
          className="card"
          style={{
            borderTop: "2px solid #4723d9",
          }}
          onSubmit={onSubmitHandler}
        >
          {/* Header */}

          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div>{title}</div>

            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>

          {/* Body */}

          <div className="card-body">
            <div className="row justify-content-center">
              {/* Asset Name */}

              <div className="col-md-6 mt-3">
                <label htmlFor="assetname">
                  <b>Asset Name *</b>
                </label>

                <CreatableSelect
                  options={assetNames}
                  placeholder="Select or Add Asset Name"
                  value={
                    formData.assetname
                      ? {
                          value: formData.assetname,
                          label: formData.assetname,
                        }
                      : null
                  }
                  onChange={(option) => {
                    setFormData((prev) => ({
                      ...prev,
                      assetname: option?.value || "",
                    }));

                    // Clear error after selection
                    setErrors((prev) => ({
                      ...prev,
                      assetname: "",
                    }));
                  }}
                  onCreateOption={(inputValue) => {
                    const newAsset = {
                      value: inputValue,
                      label: inputValue,
                    };

                    // Add new asset to dropdown
                    setAssetNames((prev) => [...prev, newAsset]);

                    // Store selected value
                    setFormData((prev) => ({
                      ...prev,
                      assetname: inputValue,
                    }));

                    // Clear error
                    setErrors((prev) => ({
                      ...prev,
                      assetname: "",
                    }));
                  }}
                  className={errors.assetname ? "is-invalid" : ""}
                  classNamePrefix="select"
                />

                {errors.assetname && (
                  <p className="text-danger">{errors.assetname}</p>
                )}
              </div>

              {/* Cost */}

              <div className="col-md-6 mt-3">
                <label htmlFor="cost">
                  <b>Cost *</b>
                </label>

                <input
                  type="number"
                  id="cost"
                  placeholder="Enter unit cost"
                  className="form-control"
                  name="cost"
                  min="0"
                  onChange={onChangeHandler}
                  value={formData.cost}
                />

                {errors.cost && <p className="text-danger">{errors.cost}</p>}
              </div>

              {/* Quantity */}

              <div className="col-md-6 mt-3">
                <label htmlFor="quantity">
                  <b>Quantity *</b>
                </label>

                <input
                  type="number"
                  id="quantity"
                  placeholder="Enter quantity"
                  className="form-control"
                  name="quantity"
                  min="1"
                  onChange={onChangeHandler}
                  value={formData.quantity}
                />

                {errors.quantity && (
                  <p className="text-danger">{errors.quantity}</p>
                )}
              </div>

              {/* Purchased Date */}

              <div className="col-md-6 mt-3">
                <label htmlFor="purchasedDate">
                  <b>Purchased Date *</b>
                </label>

                <input
                  type="date"
                  id="purchasedDate"
                  className="form-control"
                  name="purchasedDate"
                  onChange={onChangeHandler}
                  value={formData.purchasedDate}
                />

                {errors.purchasedDate && (
                  <p className="text-danger">{errors.purchasedDate}</p>
                )}
              </div>

              {/* Purchased From */}

              <div className="col-md-6 mt-3">
                <label htmlFor="purchasedFrom">
                  <b>Purchased From *</b>
                </label>

                <input
                  type="text"
                  id="purchasedFrom"
                  placeholder="Enter purchased from"
                  className="form-control"
                  name="purchasedFrom"
                  onChange={onChangeHandler}
                  value={formData.purchasedFrom}
                />

                {errors.purchasedFrom && (
                  <p className="text-danger">{errors.purchasedFrom}</p>
                )}
              </div>

              {/* Company */}

              <div className="col-md-6 mt-3">
                <label htmlFor="company">
                  <b>Company *</b>
                </label>

                <input
                  type="text"
                  id="company"
                  placeholder="Enter company"
                  className="form-control"
                  name="company"
                  onChange={onChangeHandler}
                  value={formData.company}
                />

                {errors.company && (
                  <p className="text-danger">{errors.company}</p>
                )}
              </div>

              {/* Description */}

              <div className="col-md-6 mt-3">
                <label htmlFor="description">
                  <b>Description</b>
                </label>

                <textarea
                  id="description"
                  placeholder="Enter description"
                  className="form-control"
                  name="description"
                  rows="3"
                  onChange={onChangeHandler}
                  value={formData.description}
                />

                {errors.description && (
                  <p className="text-danger">{errors.description}</p>
                )}
              </div>
              <div className="col-md-6 mt-3"></div>
            </div>

            {/* Submit */}

            <button type="submit" className="btn btn-primary btn-sm mt-4">
              Add Asset Purchase
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
